import { CompanyErrorNotificationDto } from 'src/Libs/company-settings/dto'
import { CompanyErrorNotificationModel } from 'src/Libs/company-settings/models'

const DEFAULT_MISSING_NUMBER_VALUE = -1

const errorNotificationToToModelTransformer = (resource: CompanyErrorNotificationDto): CompanyErrorNotificationModel[] => {
  return (resource.id || []).map(
    (value: number, index: number) =>
      ({
        id: value,
        userId: (resource.userId || [])[index] ?? DEFAULT_MISSING_NUMBER_VALUE,
        email: (resource.email || [])[index] ?? '',
        firstName: (resource.firstName || [])[index] ?? '',
        lastName: (resource.lastName || [])[index] ?? '',
      } as CompanyErrorNotificationModel)
  )
}

export default errorNotificationToToModelTransformer
